import { connectRouter } from 'connected-react-router';
import { History } from 'history';

const historyReducer = (history: History<unknown>) => connectRouter(history);

export default historyReducer;
